import { API_TEMPLATE } from '../libs/constant'
import { post, get, put } from '../libs/query'

const statisticReportApi = {
  listStatisticReport({ criteria, size, page }, sortPayload = {}) {
    const path = API_TEMPLATE.STATISTICS_REPORT_FILTER
    return post(path, { criteria, size, page, ...sortPayload })
  },
  getDataDetailStatistics(id) {
    return get(`${API_TEMPLATE.GET_STATISTICS_REPORT_DETAIL}?id=${id}`)
  },
  getDataEvaluateSessionId(id) {
    return get(`${API_TEMPLATE.GET_EVALUATE_SESSION_ID}?id=${id}`)
  },
  getLessonContentBySessionId(sessionId) {
    return get(`${API_TEMPLATE.GET_LESSON_CONTENT_BY_SESSION_ID}?sessionId=${sessionId}`)
  },
  updateStatistics(payload) {
    const path = API_TEMPLATE.UPDATE_STATISTICS_REPORT_DETAIL
    return post(path, payload)
  },
  updateQuarterlyExam(payload) {
    const path = API_TEMPLATE.UPDATE_QUARTERLY_EXAM
    return post(path, payload)
  },
  getQuarterlyExam({ id, studentId }) {
    const path = API_TEMPLATE.GET_QUARTERLY_EXAM
    return get(`${path}/${id}/quarterly-exam/${studentId}`)
  },
  getSuggestPoint(id) {
    const path = API_TEMPLATE.GET_SUGGEST_POINT_DETAIL
    return get(`${path}?id=${id}`)
  },
  exportStatisticReport({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.STATISTICS_REPORT_EXPORT}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload,
    )
  },
  exportQuarterlyExamReport({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.QUARTERLY_EXAM_REPORT_EXPORT}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload,
    )
  },
}

export default statisticReportApi
